import { atomWithStorage } from 'jotai/utils';
import type { SiteGroupExperience } from '@/services/lookupService';

// Cached to localStorage so a returning user boots into their facility's theme
// and feature flags without flashing the default purple palette first. Refreshed
// every app load via useSiteGroupExperience when a facility is selected.
export const siteGroupExperienceAtom = atomWithStorage<SiteGroupExperience | null>(
  'site_group_experience',
  null
);
